import React from "react";
import GenreCard from "../../Components/GenreCard";
import { Link } from "react-router-dom";
import { genera } from "../../dummyData/Genera";

function GenreSection() {

  return (
    <div className="lg:px-20 md:px-10 px-2 py-20 ">
      <div className="flex justify-between lg:flex-row flex-col lg:px-20 px-5">
        <p className="font-bold text-2xl pb-10"> Browse Media by Genre</p>
        <div className="flex justify-between items-center lg:space-x-5 space-x-1 lg:flex-row flex-col lg:space-y-0 space-y-5 pb-5">
          <Link to="digital">
            <button className="bg-primary px-5 py-2 rounded-full text-white text-xs lg:w-auto w-full ">
              Veiw More
            </button>
          </Link>
          <button className="bg-[#D99EA7] px-5 py-2 rounded-full text-xs lg:w-auto w-full">
            Games
          </button>
          <button className="bg-[#D99EA7] px-5 py-2 rounded-full text-xs lg:w-auto w-full">
            Websites
          </button>
          <button className="bg-[#D99EA7] px-5 py-2 rounded-full text-xs lg:w-auto w-full">
            Facebook Groups
          </button>
        </div>
      
      </div>
      <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols1 gap-10 xs:px-10 lg:px-20">
        {genera.map((obj, k) => (
          <Link to="detail" state={obj} key={k} >
            <GenreCard img={require(`../../assets/${obj.img}.png`)} title={obj.cardName} />
          </Link>
        ))}
      </div>
      <div className="flex flex-col  items-center pt-10">
        <button
          className="bg-primary px-4 py-2 rounded-full text-white text-sm"
        >
          Veiw More
        </button>
      </div>
    </div>
  );
}

export default GenreSection;
